"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _store = require("../../redux/store");
var _planDetailsSlice = require("../../redux/planDetailsSlice");
var _offersSlice = require("../../redux/offersSlice");
var _reactI18next = require("react-i18next");
var _SubscriptionIcon = _interopRequireDefault(require("../SubscriptionIcon"));
var _Price = _interopRequireDefault(require("../Price"));
var _SkeletonWrapper = _interopRequireDefault(require("../SkeletonWrapper"));
var _planHelper = require("../../util/planHelper");
var _popupSlice = require("../../redux/popupSlice");
var _eventDispatcher = _interopRequireWildcard(require("../../util/eventDispatcher"));
var _OfferMyAccountCardStyled = require("./OfferMyAccountCardStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var EditBlockedIcon = function EditBlockedIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("style", {
        children: [".a", "{", "fill:#d3dbe6", "}", ".b", "{", "fill:#f8fafd", "}"]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      className: "a",
      width: "18",
      height: "18",
      rx: "3"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      className: "b",
      d: "M12.779 3.324a1.8 1.8 0 0 1 1.441 2.883l-.721.721-1.091-1.093-1.429-1.43.721-.721a1.794 1.794 0 0 1 1.081-.36ZM3.77 11.612l-.721 3.243 3.243-.721 6.667-6.667-2.522-2.521Zm7.338-4.194-5.045 5.045-.621-.621 5.045-5.046.621.621Z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      className: "b",
      d: "m10.139 6.289 1.322 1.322-5.287 5.286-1.321-1.322z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      className: "a",
      width: "7.476",
      height: "1.2",
      rx: ".6",
      transform: "rotate(45 -5.327 10.866)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      className: "b",
      width: "14.448",
      height: "1.4",
      rx: ".7",
      transform: "rotate(45 -1.864 6.983)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      style: {
        fill: "none"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m1 0 1 1.707H0Z",
        style: {
          stroke: "none"
        },
        transform: "rotate(-135 5.326 6.496)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m1 0 1 1.707H0L1 0Z",
        style: {
          fill: "#d3dbe6",
          stroke: "none"
        },
        transform: "rotate(-135 5.326 6.496)"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      className: "b",
      d: "m3.977 13.316.797.797a2.387 2.387 0 0 1-.964.309.7.7 0 0 1-.547-.392Z"
    })]
  });
};
EditBlockedIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18"
};
var DowngradeIcon = function DowngradeIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        transform: "translate(-421 -279)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          width: "18",
          height: "18",
          rx: "3",
          transform: "translate(421 279)",
          fill: "#d3dbe6"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          fill: "#f8fafd",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M429.844 291.486a.24.24 0 0 0 .157.056h.007a.232.232 0 0 0 .172-.075l1.966-1.688a.175.175 0 0 0 0-.273.247.247 0 0 0-.315 0l-1.6 1.376v-6.23a.209.209 0 0 0-.223-.193.209.209 0 0 0-.223.193v6.242l-1.616-1.39a.248.248 0 0 0-.315 0 .175.175 0 0 0 0 .273Z"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M430.008 291.742h-.032a.436.436 0 0 1-.263-.1l-1.987-1.712a.382.382 0 0 1-.136-.287.382.382 0 0 1 .133-.288.442.442 0 0 1 .29-.106.439.439 0 0 1 .287.1l1.286 1.1v-5.797a.409.409 0 0 1 .423-.393.409.409 0 0 1 .423.393v5.795l1.27-1.095a.436.436 0 0 1 .287-.1.44.44 0 0 1 .29.107.382.382 0 0 1 .133.288.382.382 0 0 1-.135.287l-1.958 1.678a.435.435 0 0 1-.311.13Zm-.007-.409.022.006a.031.031 0 0 0 .01-.007l.017-.017 1.94-1.666a.043.043 0 0 0-.026.007l-1.933 1.66v-6.654a.075.075 0 0 0-.045 0v6.665l-1.947-1.675a.043.043 0 0 0-.027-.008l1.963 1.69h.008Z"
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M9 2h.007A.55.55 0 0 1 9 3.1.55.55 0 0 1 9 2Zm2.81.642a.548.548 0 0 1 .24.058h.007a.55.55 0 0 1-.482.989.55.55 0 0 1 .235-1.047Zm2.248 1.806a.549.549 0 0 1 .431.209.55.55 0 0 1-.864.681.55.55 0 0 1 .431-.892Zm1.24 2.6a.55.55 0 0 1 .536.429v.007a.55.55 0 1 1-1.074.237.551.551 0 0 1 .54-.671Zm-.02 2.885a.55.55 0 0 1 .536.674v.007a.55.55 0 1 1-1.071-.253.55.55 0 0 1 .535-.426ZM14 12.52a.55.55 0 0 1 .427.9.551.551 0 1 1-.852-.7.549.549 0 0 1 .425-.2Zm-2.269 1.775a.55.55 0 0 1 .234 1.048h-.005a.552.552 0 0 1-.466-1 .548.548 0 0 1 .237-.048Zm-2.823.6h.012A.553.553 0 0 1 8.906 16H8.9a.55.55 0 0 1 .008-1.1Zm-2.8-.683a.548.548 0 0 1 .246.059.55.55 0 0 1-.492.984h-.006a.55.55 0 0 1 .248-1.041Zm-2.224-1.833a.549.549 0 0 1 .436.215.55.55 0 0 1-.871.672.55.55 0 0 1 .435-.885Zm-1.2-2.62a.55.55 0 0 1 .538.439.55.55 0 0 1-1.077.225v-.003a.55.55 0 0 1 .539-.661Zm.06-2.884a.551.551 0 0 1 .534.684.55.55 0 0 1-1.069-.259v-.011a.55.55 0 0 1 .534-.414Zm1.311-2.566a.55.55 0 0 1 .421.9.55.55 0 0 1-.844-.705.549.549 0 0 1 .423-.195Zm2.298-1.743a.55.55 0 0 1 .226 1.052.55.55 0 0 1-.453-1h.005a.548.548 0 0 1 .222-.052Z",
        fill: "#f8fafd"
      })]
    })
  });
};
DowngradeIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18"
};
var UpgradeIcon = function UpgradeIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        transform: "rotate(180 219.5 148.5)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          width: "18",
          height: "18",
          rx: "3",
          transform: "translate(421 279)",
          fill: "#d3dbe6"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          fill: "#f8fafd",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M429.844 291.486a.24.24 0 0 0 .157.056h.007a.232.232 0 0 0 .172-.075l1.966-1.688a.175.175 0 0 0 0-.273.247.247 0 0 0-.315 0l-1.6 1.376v-6.23a.209.209 0 0 0-.223-.193.209.209 0 0 0-.223.193v6.242l-1.616-1.39a.248.248 0 0 0-.315 0 .175.175 0 0 0 0 .273Z"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M430.008 291.742h-.032a.436.436 0 0 1-.263-.1l-1.987-1.712a.382.382 0 0 1-.136-.287.382.382 0 0 1 .133-.288.442.442 0 0 1 .29-.106.439.439 0 0 1 .287.1l1.286 1.1v-5.797a.409.409 0 0 1 .423-.393.409.409 0 0 1 .423.393v5.795l1.27-1.095a.436.436 0 0 1 .287-.1.44.44 0 0 1 .29.107.382.382 0 0 1 .133.288.382.382 0 0 1-.135.287l-1.958 1.678a.435.435 0 0 1-.311.13Zm-.007-.409.022.006a.031.031 0 0 0 .01-.007l.017-.017 1.94-1.666a.043.043 0 0 0-.026.007l-1.933 1.66v-6.654a.075.075 0 0 0-.045 0v6.665l-1.947-1.675a.043.043 0 0 0-.027-.008l1.963 1.69h.008Z"
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M9 16h-.007A.55.55 0 0 1 9 14.9.55.55 0 0 1 9 16Zm-2.81-.642a.548.548 0 0 1-.24-.058h-.007a.55.55 0 0 1 .482-.989.55.55 0 0 1-.235 1.047Zm-2.248-1.806a.549.549 0 0 1-.431-.209.55.55 0 0 1 .864-.681.55.55 0 0 1-.431.892Zm-1.24-2.6a.55.55 0 0 1-.536-.429v-.007a.55.55 0 1 1 1.074-.237.551.551 0 0 1-.54.671Zm.02-2.885a.55.55 0 0 1-.536-.674v-.007a.55.55 0 1 1 1.071.253.55.55 0 0 1-.535.426ZM4 5.48a.55.55 0 0 1-.427-.9.551.551 0 1 1 .852.7.549.549 0 0 1-.425.2Zm2.269-1.775a.55.55 0 0 1-.234-1.048h.005a.552.552 0 0 1 .466 1 .548.548 0 0 1-.237.048Zm2.823-.6H9.08A.553.553 0 0 1 9.094 2H9.1a.55.55 0 0 1-.008 1.1Zm2.8.683a.548.548 0 0 1-.246-.059.55.55 0 0 1 .492-.984h.006a.55.55 0 0 1-.248 1.041Zm2.224 1.833a.549.549 0 0 1-.436-.215.55.55 0 0 1 .871-.672.55.55 0 0 1-.435.885Zm1.2 2.62a.55.55 0 0 1-.538-.439.55.55 0 0 1 1.077-.225v.003a.55.55 0 0 1-.539.661Zm-.06 2.884a.551.551 0 0 1-.534-.684.55.55 0 0 1 1.069.259v.011a.55.55 0 0 1-.534.414Zm-1.311 2.566a.55.55 0 0 1-.421-.9.55.55 0 0 1 .844.705.549.549 0 0 1-.423.195Zm-2.298 1.743a.55.55 0 0 1-.226-1.052.55.55 0 0 1 .453 1h-.005a.548.548 0 0 1-.222.052Z",
        fill: "#f8fafd"
      })]
    })
  });
};
UpgradeIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18"
};
var PauseIcon = function PauseIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(-819 -375)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        width: "22",
        height: "22",
        rx: "3",
        transform: "translate(819 375)",
        fill: "#d3dbe6",
        opacity: ".679"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M824.932 391.752v-11.5h3.419v11.5Zm6.719 0v-11.5h3.419v11.5Z",
        fill: "#f8fafd",
        stroke: "#dde4ee",
        strokeWidth: ".6"
      })]
    })
  });
};
PauseIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22"
};
const OfferMyAccountCard = _ref => {
  let {
    offerId
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const dispatch = (0, _store.useAppDispatch)();
  const {
    data: currentPlan,
    loading
  } = (0, _store.useAppSelector)(_planDetailsSlice.selectCurrentPlan);
  const {
    pauseOffersIDs,
    offers
  } = (0, _store.useAppSelector)(_offersSlice.selectOffers);
  const {
    data: switchDetailsStore
  } = (0, _store.useAppSelector)(_planDetailsSlice.selectSwitchDetails);
  const {
    offerType,
    offerTitle,
    nextPaymentPrice,
    totalPrice,
    nextPaymentCurrency,
    customerCurrency,
    paymentMethod,
    pendingSwitchId,
    expiresAt,
    period,
    status,
    isExternallyManaged
  } = currentPlan.find(sub => sub.offerId === offerId) || {};
  const currency = _planHelper.currencyFormat[nextPaymentCurrency || customerCurrency]; // use customerCurrency for passes

  const pendingSwitchDetails = pendingSwitchId ? switchDetailsStore[pendingSwitchId] : {};

  // PAUSE FEATURE
  const isPaused = pauseOffersIDs.includes(offerId);
  const isPauseInProgress = pendingSwitchDetails ? pauseOffersIDs === null || pauseOffersIDs === void 0 ? void 0 : pauseOffersIDs.includes(pendingSwitchDetails === null || pendingSwitchDetails === void 0 ? void 0 : pendingSwitchDetails.toOfferId) : false;
  const generateDescription = () => {
    const renewalDate = expiresAt === _planHelper.INFINITE_DATE ? t('currentplan.next-season-start', 'the next season start') : (0, _planHelper.dateFormat)(expiresAt);
    if (offerType === 'S' && status === 'active' && !pendingSwitchId) {
      return "".concat(t('currentplan.subscription.renews-info', 'Renews automatically on {{renewalDate}}', {
        renewalDate
      }));
    }
    if (offerType === 'S' && status === 'cancelled') {
      return "".concat(t('currentplan.subscription.expire-info', 'This plan will expire on {{renewalDate}}', {
        renewalDate
      }));
    }
    if (offerType === 'P') {
      return "".concat(t('currentplan.pass.expires-on', 'Expires on'), " ").concat((0, _planHelper.dateFormat)(expiresAt));
    }
    return '';
  };
  const getPendingSwitchCopy = () => {
    var _offers$find;
    if (!pendingSwitchDetails) return null;
    const subscriptionExpirationDate = expiresAt === _planHelper.INFINITE_DATE ? t('offer-card.next-season-start', 'the next season start') : (0, _planHelper.dateFormat)(expiresAt);
    const {
      fromOfferId,
      toOfferId
    } = pendingSwitchDetails;
    const toOfferIdTitle = (_offers$find = offers.find(_ref2 => {
      let {
        longId
      } = _ref2;
      return longId === toOfferId;
    })) === null || _offers$find === void 0 ? void 0 : _offers$find.title;
    const translatedTitle = t("offer-title-".concat(fromOfferId), offerTitle);
    const translatedSwitchTitle = t("offer-title-".concat(toOfferId), toOfferIdTitle);

    // PAUSE FEATURE
    if (isPauseInProgress) {
      return t('offer-card.info-box.pause-information-text', 'Your current plan will be paused starting on {{subscriptionExpirationDate}}. While your subscription is paused, you won’t be charged for, and you won’t have access to, {{ translatedTitle }}. You can cancel this pause request at any time.', {
        subscriptionExpirationDate,
        translatedTitle
      });
    }
    switch (pendingSwitchDetails.algorithm) {
      case 'IMMEDIATE_WITHOUT_PRORATION':
        return t('offer-card.switch-details.immediate-without-proration', "Your switch is pending and should be completed within few minutes. You will be charged a new price starting {{subscriptionExpirationDate}}.{{translatedSwitchTitle}} renews automatically. You can cancel anytime.", {
          subscriptionExpirationDate,
          translatedSwitchTitle
        });
      case 'IMMEDIATE_AND_CHARGE_WITH_REFUND':
      case 'IMMEDIATE_AND_CHARGE_WITHOUT_PRORATION':
        return t('offer-card.switch-details.immediate-and-charge-with-refund-or-without-proration', "Your switch is pending and should be completed within few minutes. You will be charged a new price immediately and get access to {{translatedSwitchTitle}}. You can cancel anytime.", {
          translatedSwitchTitle
        });
      case 'DEFERRED':
        return t('offer-card.switch-details.deferred', "Your switch is pending. You will have access to {{translatedTitle}} until {{subscriptionExpirationDate}}. From that time you will be charged your new price and will have access to {{translatedSwitchTitle}}. You can cancel this at any time.", {
          translatedTitle,
          subscriptionExpirationDate,
          translatedSwitchTitle
        });
      default:
        return '';
    }
  };
  const getDescription = () => {
    if (pendingSwitchId) return getPendingSwitchCopy();
    if (isExternallyManaged) {
      if (!paymentMethod) {
        return t('offer-card.error.inapp-external-no-pmt-method', 'Use an external service to edit the plan.');
      }
      return t('offer-card.error.inapp-external', "".concat(paymentMethod ? "Subscription purchased via ".concat(paymentMethod, ". ") : "", " Use an external service to edit the plan."), {
        paymentMethod
      });
    }
    return '';
  };
  const getIcon = () => {
    if (isPauseInProgress) return PauseIcon;
    if ((pendingSwitchDetails === null || pendingSwitchDetails === void 0 ? void 0 : pendingSwitchDetails.direction) === 'downgrade') return DowngradeIcon;
    if ((pendingSwitchDetails === null || pendingSwitchDetails === void 0 ? void 0 : pendingSwitchDetails.direction) === 'upgrade') return UpgradeIcon;
    return EditBlockedIcon;
  };
  const IconComponent = getIcon();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_OfferMyAccountCardStyled.WrapperStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
        showChildren: !loading,
        width: 50,
        height: 50,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionIcon.default, {
          period: period || offerType,
          isPaused: isPaused
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_OfferMyAccountCardStyled.InnerWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
          showChildren: !loading,
          width: 200,
          margin: "0 10px 10px 10px",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferMyAccountCardStyled.TitleStyled, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: t("offer-title-".concat(offerId), offerTitle)
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
          showChildren: !loading,
          width: 300,
          margin: "0 10px 10px 10px",
          children: generateDescription() && /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferMyAccountCardStyled.DescriptionStyled, {
            dangerouslySetInnerHTML: {
              __html: generateDescription()
            }
          })
        })]
      }), !isPaused && /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferMyAccountCardStyled.PriceWrapperStyled, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
          showChildren: !loading,
          width: 80,
          height: 30,
          children: period && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Price.default, {
            currency: currency,
            price: nextPaymentPrice || totalPrice,
            period: period !== 'season' ? t("offer-price.period-".concat(period), period) : null
          })
        })
      })]
    }), getDescription() && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_OfferMyAccountCardStyled.SubBoxStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(IconComponent, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_OfferMyAccountCardStyled.SubBoxContentStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferMyAccountCardStyled.BoxTextStyled, {
          dangerouslySetInnerHTML: {
            __html: getDescription() || ''
          }
        }), pendingSwitchId && (pendingSwitchDetails === null || pendingSwitchDetails === void 0 ? void 0 : pendingSwitchDetails.algorithm) === 'DEFERRED' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferMyAccountCardStyled.SubBoxButtonStyled, {
          onClick: () => {
            var _offers$find2;
            (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_CANCEL_SWITCH_BUTTON_CLICKED, {
              pendingSwitchId,
              fromOfferId: pendingSwitchDetails.fromOfferId,
              toOfferId: pendingSwitchDetails.toOfferId
            });
            dispatch((0, _popupSlice.showPopup)({
              type: isPauseInProgress ? _popupSlice.POPUP_TYPES.CANCEL_PAUSE_POPUP : _popupSlice.POPUP_TYPES.CANCEL_SWITCH_POPUP,
              data: {
                pendingSwitchId,
                switchDirection: pendingSwitchDetails.direction,
                switchOfferTitle: pendingSwitchDetails && ((_offers$find2 = offers.find(_ref3 => {
                  let {
                    longId
                  } = _ref3;
                  return longId === pendingSwitchDetails.toOfferId;
                })) === null || _offers$find2 === void 0 ? void 0 : _offers$find2.title),
                baseOfferTitle: offerTitle,
                baseOfferExpirationDate: expiresAt,
                baseOfferPrice: "".concat(currency).concat(nextPaymentPrice)
              }
            }));
          },
          children: isPauseInProgress ? t('offer-card.cancel-pause-button', 'Cancel pause') : t('offer-card.cancel-switch', 'Cancel switch')
        })]
      })]
    })]
  });
};
var _default = exports.default = OfferMyAccountCard;